import React, { useEffect } from "react";
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { useIntl } from "react-intl";
import { Button, Tooltip } from "@gpstrackit/gtc-react-controls";
import { reactiveIncident, searchHistoryIncidents } from "Redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { GetFormatForMoment } from "Core/data/Helpers";
import moment from "moment";
import { NotificationManager } from "Components/Notifications";
import { reset } from "../../redux/slice";

const Reactivate = ({ open, setOpen, incident, filters }) => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const {
    resReactive: res,
    loadingResReactive: loading,
    errorResReactive: errorRes,
  } = useSelector((state) => state.historyIncidentsRedux);
  const { user } = useSelector((state) => state.securityRedux);
  const { dateformat } = user;
  const format = GetFormatForMoment(dateformat);


  useEffect(() => {
    if (loading) return;
    if (!loading && res?.id) {
      dispatch(searchHistoryIncidents(filters));
      NotificationManager.success(
        messages["reactivateMessage_incident_history"],
        messages["reactivateMessageTitle_incident_history"],
        3000,
        null,
        null,
        "success",
        null
      );
    }
    if(!loading && errorRes?.error){
      NotificationManager.warning(
        messages["reactivateMessageError_incident_history"],
        messages["reactivateMessageTitle_incident_history"],
        3000,
        null,
        null,
        "warning",
        null
      );
    }
    dispatch(reset({
      resReactive: null, 
      loadingResReactive: false,
      errorResReactive: null
    }))
    return setOpen(false);
  }, [res, loading]);

  const reactivateAction = () => {
    dispatch(reactiveIncident({id: incident?.id, unitId: incident?.unitId}))
  }

  return (
    <Modal
      title={messages["reactive_incident_history"]}
      open={open}
      position="right"
      size="small"
      style={{ overflow: "hidden" }}
      className="overflow-hidden"
      handleClose={() => setOpen(false)}
    >
      <ModalBody
        style={{
          overflow: "hidden",
          marginBottom: 0,
          overflowY: "auto",
          height: "80vh",
        }}
      >
        <div style={{ padding: "20px" }}>
          {messages["reactivate_message_incident_history"]}
        </div>
        <div style={{marginLeft: '20px'}}>
            <p style={{display: 'flex'}}>{messages['incidentName_incident_history'] } {
              incident?.name?.length > 20 ?
                <Tooltip style={{marginLeft: '10px'}} title={incident?.name}>
                  {incident?.name.slice(0, 20)} ...
                </Tooltip> :
                incident?.name
            }</p>
            <p style={{display: 'flex'}}>{messages['incidentVehicle_incident_history'] } {
              incident?.label?.length > 20 ?
              <Tooltip style={{marginLeft: '10px'}} title={incident?.label}>
                {incident?.label.slice(0, 20)} ...
              </Tooltip> :
              incident?.label
            }</p>
            <p>{messages['incidentStart_incident_history'] } {moment(incident?.start).format(`${format} hh:mm:ss a`)}</p>
        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
        <div style={{ display: "flex", width: "100%", justifyContent: "end" }}>
          <Button
            style={{ marginRight: "5px" }}
            disabled={loading}
            onClick={() => setOpen(false)}
            variant="secondary"
          >
            {messages["cancel"]}
          </Button>

          <Button
            disabled={loading}
            onClick={(e) => {
              if (e) e.preventDefault();
              reactivateAction();
            }}
            variant="primary"
          >
            {messages["reactiveConfirm_incident_history"]}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default Reactivate;
